import React, { Component } from 'react'
import Tab from './Tab'
import Table from './Table'

export default class extends Component {
  render() {
    return (
      <div>
        <div style={{ color: '#333', fontSize: 16 }}>推送数据</div>
        <Tab store={this.props.store} />
        <Table store={this.props.store} />
      </div>
    )
  }
}
